import { Component } from '@angular/core';

@Component({
  selector: 'uni-chart-tooltip',
  templateUrl: './uni-chart-tooltip.component.html',
  styleUrls: ['./uni-chart-tooltip.component.scss'],
})
export class UniChartTooltipComponent { }
